/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Compare_Col_AutocadInputs */

const en_cad_compare_col_autocad = /** @type {(inputs: Cad_Compare_Col_AutocadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AutoCAD`)
};

/**
* | output |
* | --- |
* | "AutoCAD" |
*
* @param {Cad_Compare_Col_AutocadInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_compare_col_autocad = /** @type {((inputs?: Cad_Compare_Col_AutocadInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Compare_Col_AutocadInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_compare_col_autocad(inputs)
});
export { cad_compare_col_autocad as "cad.compare.col_autocad" }